import { FilterBigIcon } from '@images/icons';
import { IconButton } from '@material-ui/core';
import React from 'react';

interface props {
  handleFiltersClick: (e) => void;
}

export const LettersFilterLabel = ({ handleFiltersClick }: props) => {
  return (
    <>
      <IconButton
        size="small"
        color="primary"
        aria-label="filtering"
        component="div"
        data-testid="open-filters"
        onClick={handleFiltersClick}
      >
        <FilterBigIcon />
      </IconButton>
    </>
  );
};
